import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../../hooks/use_translation';
import BadgeSatisfiedCustomerGuarantee from '../badges/badge-satisfied-customer-guarantee';
import SectionHeader from './section-header';

const SectionSatisfiedCustomerGuarantee = ({ ...props }) => {
	const { t } = useTranslation(
		'component_section_satisfied_customer_guarantee',
	);
	return (
		<>
			<div className="container" {...props}>
				<div className="row align-items-center justify-content-between">
					<div className="col-xl-6 col-md-12 ">
						<div className="mb-3 mb-xl-0">
							<BadgeSatisfiedCustomerGuarantee alt={t('t1')} />
						</div>
					</div>
					<div className="col-xl-5 col-md-10 mt-4 mt-lg-0">
						<div className="row">
							<div className="col-xxl-12">
								<SectionHeader
									headingType="p"
									hideButton={true}
									size="lg"
									subHeadingType="h3"
									title={t('t1')}
								/>
							</div>
						</div>

						<div className="mb-lg-4">{t('t2')}</div>
					</div>
				</div>
			</div>
		</>
	);
};

SectionSatisfiedCustomerGuarantee.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	position: PropTypes.string,
};

export default SectionSatisfiedCustomerGuarantee;
